import React from 'react';
import './Clients.css';
import sixbellLogo from '../images/nosotros/sixbell-logo.avif';
import BHPLogo from '../images/nosotros/BHP_2017_logo.svg.png';
import CheilWorldwideLogo from '../images/nosotros/Cheil_Worldwide_logo.svg.png';
import amsaLogo from '../images/nosotros/logo-amsa.png';
import chileCompraLogo from '../images/nosotros/logo-chilecompra-original.png';
import MGRecursoLogo from '../images/nosotros/MGRecurso-8@4x1.png';
import patrimoreLogo from '../images/nosotros/patrimore-newlogo.webp';
import pepperstone from '../images/nosotros/PepperstoneLogo.png';
import becLogo from '../images/nosotros/bec-nasdaq-logo.png';
import grupoInteligenciaLogo from '../images/nosotros/grupo-inteligencia-logo.png';

const Clients = ({ title = null, className = "" }) => {
  const logos = [
    { src: becLogo, alt: 'BEC - Bolsa Electrónica de Chile (powered by Nasdaq)' },
    { src: grupoInteligenciaLogo, alt: 'GI - Grupo Inteligencia' },
    { src: MGRecursoLogo, alt: 'MG Recurso' },
    { src: sixbellLogo, alt: 'Sixbell' },
    { src: amsaLogo, alt: 'AMSA' },
    { src: BHPLogo, alt: 'BHP' },
    { src: CheilWorldwideLogo, alt: 'Cheil Worldwide' },
    { src: pepperstone, alt: 'Pepperstone' },
    { src: patrimoreLogo, alt: 'Patrimore' },
    { src: chileCompraLogo, alt: 'ChileCompra' },
  ];

  // Duplicar el array de logos para un loop infinito perfectamente seamless
  const duplicatedLogos = [...logos, ...logos];

  return (
    <div className={`clients-marquee-wrapper ${className}`}>
      {title && (
        <p className="clients-caption">
          {title}
        </p>
      )}
      <div className="clients-track-container">
        <div className="clients-track">
          {duplicatedLogos.map((item, index) => (
            <img
              key={`client-${index}`}
              src={item.src}
              alt={item.alt}
              className="client-logo-item"
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Clients;
